// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"5f13b5cc","572":"03341889","601":"8c4924e2","693":"7412f07a"}[chunkId] + ".chunk.js";
};